import { createAction } from '@reduxjs/toolkit';
import type { IAddAutoRenewAction } from 'reactApp/modules/buySubscription/buySubscription.types';
import type {
    AddAutoRenewAction,
    AddAutoRenewWithDiscountAction,
    AddOrUpdateCardMobileAction,
    CancelAutoRenewAction,
    CancelAutoRenewMobileAction,
    RenewMobileAction,
} from 'reactApp/modules/subscriptionRenewal/subscriptionRenewal.types';

const cancelAutoRenew = createAction<CancelAutoRenewAction>('subscriptionRenewal/cancelAutoRenew');
const addAutoRenew = createAction<AddAutoRenewAction>('subscriptionRenewal/addAutoRenew');
// tempexp_18907-next-line
const addAutoRenewWithDiscount = createAction<AddAutoRenewWithDiscountAction>('subscriptionRenewal/addAutoRenewWithDiscount');
const cancelAutoRenewMobile = createAction<CancelAutoRenewMobileAction>('subscriptionRenewal/cancelAutoRenewMobile');
const renewMobile = createAction<RenewMobileAction>('subscriptionRenewal/renewMobile');
const addOrUpdateCardMobile = createAction<AddOrUpdateCardMobileAction>('subscriptionRenewal/addOrUpdateCardMobile');
const turnOnAutopayment = createAction<IAddAutoRenewAction>('subscriptionRenewal/turnOnAutopayment');

export const SubscriptionRenewalActions = {
    cancelAutoRenew,
    addAutoRenew,
    addAutoRenewWithDiscount,
    cancelAutoRenewMobile,
    renewMobile,
    addOrUpdateCardMobile,
    turnOnAutopayment,
} as const;
